import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col, Avatar } from "antd";
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  LinkOutlined,
} from "@ant-design/icons";
import bannerImage3 from "../../assets/echoo.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";

const MisogynyOnline = () => {
  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          // style={{
          //   background: `url(${bannerImage3}) no-repeat center center/cover`,
          // }}
          style={{
            backgroundColor: "black",
          }}
        >
          <h1>Misogyny Online: Breaking the Cycle</h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <Avatar
                    size={64}
                    src="https://thispersondoesnotexist.com/"
                  />

                  <div className={styles.authorText}>
                    <h3>Harleen Cook</h3>
                    <p></p>
                  </div>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May 29, 2025</p>
                <h1 className={styles.postTitle}>
                  Misogyny Online: Breaking the Cycle
                </h1>
                <p className={styles.author}>By Harleen Cook</p>
              </div>
              <div className={styles.contents}>
                <h4>Contents</h4>
                <ul>
                  <li>
                    <a href="#letter">A letter from Harleen & Andrew</a>
                  </li>
                  <li>
                    <a href="#misogyny">
                      What is Misogyny—and Why It’s Everyone’s Problem
                    </a>
                  </li>
                  <li>
                    <a href="#mainstream">
                      How Mainstream Social Media Fuels the Fire
                    </a>
                  </li>
                  <li>
                    <a href="#tate">
                      What About Andrew Tate? The Myth of Power, the Science of
                      Weakness
                    </a>
                  </li>
                  <li>
                    <a href="#animal">What Animal Behaviour Teaches Us</a>
                  </li>
                  <li>
                    <a href="#netflix">What Netflix’s Adolescence Got Right</a>
                  </li>

                  <li>
                    <a href="#buddyhood">
                      The Buddyhood: Stories That Start Conversations
                    </a>
                  </li>
                  <li>
                    <a href="#newway">
                      A New Way Online: Why We Built {BRAND.domainLabel}
                    </a>
                  </li>
                  <li>
                    <a href="#forward">A Path Forward—Together</a>
                  </li>
                  <li>
                    <a href="#references">References</a>
                  </li>
                </ul>
              </div>

              <div className={styles.share}>
                <h4>Share This Blog</h4>
                <div className={styles.icons}>
                  <FacebookFilled />
                  <TwitterSquareFilled />
                  <LinkedinFilled />
                  <LinkOutlined />
                </div>
              </div>
            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p className={styles.intro} id="letter">
                <strong>
                  From Harleen and Andrew, founders of The Buddyhood Ltd and
                  {BRAND.domainLabel}.
                </strong>
              </p>
              <p className={styles.intro} id="letter">
                <em>
                  As parents ourselves, we look at our son and daughter and
                  wonder; are we empowering them to be their best selves? In
                  this world, where children are being ever influenced by
                  attention seeking, weaker personalities, we ponder if our
                  children will be strong enough to believe in themselves and
                  stand up. A key crisis that is unfolding in society is
                  misogyny… but it’s always been there. We feel it more with our
                  youth because they are following more and more extreme ideals,
                  but are they the ones who are completely at fault? Misogyny
                  thrives when there is insecurity and weakness of character. In
                  the empowering rhetoric to bring the world into equal balance,
                  have men felt disempowered and is this their way of hitting
                  back? Empowerment belongs to all.
                </em>
              </p>

              <p>
                So, let’s explore misogyny, which is so counter to our
                development and survival as humans, yet more and more young
                people are on this path to self-destruct. We offer a solution,
                but before that, we need to understand the problem.
              </p>

              {/* <img
                src="/Images/brainworks.png"
                alt="Brain in a cage"
                className={styles.featureImage}
              /> */}

              <h2 id="misogyny">
                What is Misogyny—and Why It’s Everyone’s Problem
              </h2>
              <p>
                Misogyny isn’t limited to violent acts—it’s the everyday
                cultural undercurrent that says women are worth less than men.
                It’s in jokes, comments, silences, and the systemic
                normalisation of power imbalances. This is nothing new and there
                have been many movements to counter this over the years.
              </p>
              <p>However, online, this misogynistic rhetoric is spreading.</p>
              <p>
                A 2023 Amnesty International UK report revealed that over 1 in 3
                women aged 18–24 had experienced abuse on social media. Half
                said they’d reduced their online presence as a result. The
                effects are devastating:
              </p>
              <p>
                <strong> Mental Health Impacts </strong>{" "}
              </p>
              <p>
                A 2023 BMJ study found that exposure to toxic online
                content—especially misogynistic and body-shaming
                material—contributed to a 67% rise in eating disorders and a 22%
                rise in youth self-harm during the pandemic.
              </p>
              <p>
                <strong> Economic Cost</strong>{" "}
              </p>
              <p>
                According to a 2024 Ipsos UK report for the Home Office,
                violence against women and girls—including online abuse—costs
                the UK an estimated £66 billion per year. That includes:
              </p>
              <ul className={styles.references}>
                <li>NHS and mental health services</li>
                <li>Criminal justice and legal costs</li>
                <li>Lost productivity</li>
                <li>Long-term support and recovery care</li>
              </ul>

              <p>
                This isn’t just affecting women. It’s shaping how all of us
                relate to each other—and to ourselves.
              </p>
              <h2 id="mainstream">
                How Mainstream Social Media Fuels the Fire
              </h2>
              <p>
                Misogyny is inherently driven within individuals who consider
                themselves incapable and therefore create a façade of strength
                as their external profile. The online world assists in creating
                these “imaginary” personalities and is therefore a thriving
                environment for this kind of viewpoint to colonise and infect
                others who may also be feeling worthless. Here’s what makes it
                worse:{" "}
                <strong>
                  {" "}
                  social media platforms are built to reward outrage.
                </strong>
              </p>
              <p>
                Instagram, YouTube, TikTok, X—they’re designed to boost whatever
                gets the most reactions. That often means hate, extremism, and
                shock value spread faster than anything compassionate or
                constructive… or even real.
              </p>
              <p>
                A 2024 UCL study confirmed that these platforms expose teenage
                boys to misogynistic content—even when they don’t go looking for
                it. Their algorithms promote content that glorifies control,
                dominance, and emotional manipulation.
              </p>
              <p>
                The deeper they scroll, the more these ideas become normalised.
              </p>

              <h2 id="tate">
                What About Andrew Tate? The Myth of Power, the Science of
                Weakness
              </h2>
              <p>
                You can’t talk about this without mentioning Andrew Tate—the
                influencer who made a living off hypermasculine, misogynistic
                content, which wasn’t necessarily real and often was staged or
                filtered.
              </p>
              <p>
                Andrew Tate was a kickboxer whose career was cut short due to
                injuries. He transitioned to become a social media influencer,
                focusing on misogynistic content. One must question, was this
                because he felt worthless and weak as he could no longer compete
                as a kickboxer? Misogyny, at its core, isn’t a show of
                strength—it’s a manifestation of insecurity.
              </p>
              <p>
                A 2017 study in the Journal of Personality and Social Psychology
                found that men who feel their masculinity is fragile or “under
                threat” are far more likely to express hostile sexism—especially
                when they feel rejected or inferior (Vandello et al., 2017).
              </p>
              <p>
                This aligns with what we see in nature too, and perhaps, what we
                are seeing with Andrew Tate and his personal failure as an
                athlete due to injuries.
              </p>

              <h2 id="animal">What Animal Behaviour Teaches Us</h2>
              <p>
                In the animal kingdom, dominance displays often come from the
                weakest individuals, not the strongest.
              </p>
              <p>
                Among primates, lower-status males—those with fewer allies or
                less reproductive success—are more likely to act out with
                aggression. Powerful, high-ranking males tend to be more secure,
                calm, and socially intelligent.
              </p>
              <p>
                The same applies to wolves: true “alphas” don’t bark the
                loudest. They lead through respect
                <a
                  href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2786061/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  (Mech, 1999)
                </a>
                .
              </p>
              <p>
                So, when influencers like Tate market control and cruelty as
                masculine ideals, they’re actually selling emotional fragility,
                insecurity and weakness.
              </p>
              <p>
                Unfortunately, that true message is being distorted in real
                life:{" "}
              </p>

              <ul className={styles.references}>
                <li>
                  A 2023 NASUWT teachers’ survey found a 33% increase in sexist
                  language in UK classrooms.
                </li>
                <li>
                  70% of teachers reported students referencing Tate in
                  “concerning” or “idolising” ways.
                </li>
              </ul>
              <p>
                These aren’t evil children. They’re confused, scared and
                neglected. They’re trying to understand who they are—and they’re
                being handed a very broken script with no support or guidance in
                a collaborative way.
              </p>

              <h2 id="netflix">What Netflix’s Adolescence Got Right</h2>
              <p>
                We saw this poignantly reflected in the Netflix drama
                Adolescence—a show that captured the emotional turbulence of
                growing up in a hyper-digital, hyper-judgemental world.
              </p>
              <p>
                It didn’t moralise. It showed real feelings, confusion,
                contradictions. It gave viewers space to feel without being told
                what to think. In doing so, it sparked conversations that don’t
                usually happen in classrooms or around dinner tables.
              </p>
              <p>
                That power—to unlock discussion through story—is exactly why we
                created <strong> The Buddyhood. </strong>
              </p>

              {/* <img
                src="/Images/manForward.png"
                alt="Brain in a cage"
                className={styles.featureImage}
              /> */}
              <h2 id="buddyhood">
                The Buddyhood: Stories That Start Conversations
              </h2>
              <p>
                The Buddyhood is a growing collection of fictional stories that
                open doors into difficult conversations—about mental health,
                masculinity, consent, grief, identity, and more.
              </p>
              <p>
                We don’t write these to preach or “teach a lesson.” We write
                them to create space. Stories are bridges—and when people read
                them together, they find a way to meet in the middle.
              </p>
              <p>
                We’ve seen it in homes, schools, and book clubs: people reading
                the same story and suddenly having a real, vulnerable
                conversation—across ages, genders, and generations… without
                judgement, as buddies.
              </p>

              <h2 id="newway">A New Way Online: Why We Built {BRAND.domainLabel}</h2>
              <p>
                Of course, stories are just the beginning. We also need to
                rebuild the digital spaces where people spend most of their
                time.
              </p>
              <p>
                That’s why we created {BRAND.domainLabel}—a social platform designed
                around reflection, truth, and human connection, not filters or
                followers.
              </p>
              <p>
                on {BRAND.short}, there are no comments, no status games, no algorithm
                chasing. It’s about sharing your truth, exploring others’, and
                building compassion—online and off. Responsible freedom of
                expression is encouraged, while we ensure safety through
                pre-moderation. Which means insecurity and false bravado find it
                difficult to thrive on {BRAND.domainLabel}.
              </p>
              <p>
                Together, The Buddyhood (offline) and {BRAND.domainLabel} (online) form
                a loop of listening and connection. One that can transform not
                just how we talk, but how we live.
              </p>

              <h2 id="forward">A Path Forward—Together</h2>
              <p>
                We believe that real change starts with honest conversation.
                Those conversations need safe places—on the page, in person, and
                online.
              </p>
              <p>
                Let’s raise a generation that sees masculinity not as
                domination, but as emotional courage.
              </p>
              <p>
                Let’s build digital spaces that mirror our best selves—not our
                most reactive ones.
              </p>
              <p>
                Let’s tell stories. Let’s listen to them. Let’s do it together.
              </p>
              <p>
                This is the world we’re working towards. With books. With
                design. With you.
              </p>
              <p>
                Pull up a chair. You’re already part of it. Let’s create the
                world we all deserve.
              </p>
              <p>
                <strong>— Harleen & Andrew</strong>
                <br />
                Founders of The Buddyhood Ltd and {BRAND.domainLabel}
              </p>
              <h3 id="references"> References</h3>
              <ul className={styles.references}>
                <li>
                  Amnesty International UK (2023). Toxic Twitter and Online
                  Abuse
                </li>
                <li>
                  Ipsos UK & Home Office (2024). The Economic Cost of Violence
                  Against Women and Girls
                </li>
                <li>
                  BMJ (2023). Eating Disorders and Youth Mental Health During
                  the Pandemic
                </li>
                <li>
                  UCL (2024). Social Media Algorithms and Misogyny Exposure
                  Among Teens
                </li>
                <li>
                  NASUWT (2023). Teacher Reports on Misogyny in UK Classrooms
                </li>
                <li>
                  Vandello, J. A., et al. (2017). Precarious Manhood and Hostile
                  Sexism. Journal of Personality and Social Psychology
                </li>
                <li>
                  Mech, L. D. (1999). Alpha Status, Dominance, and Division of
                  Labor in Wolf Packs. Canadian Journal of Zoology
                </li>
                <li>Netflix (2024). Adolescence [Drama Series]</li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default MisogynyOnline;
